<template>
  <form class="domain-forwarding-form" @submit.prevent="submit">
    <div class="input">
      <div class="field-label">
      <label>Domain Name</label>
      </div>
      <input disabled :value="`https://${domain}`">
    </div>

    <Field
      label="Forwards To"
      @input="$v.resource.forwardsTo.$touch()"
      v-model="resource.forwardsTo"
      placeholder="https://my-primary-domain.com"
      helpText="This is where the domain will redirect to"
      :error="forwardsToError"/>

    <div class="btn-save">
      <Btn primary>Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'domain-forwarding-form',

  mixins: [form],

  props: {
    domain: String
  },

  computed: {
    ...errorMessages([
      'forwardsTo'
    ])
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      forwardsTo: {required}
    }
  }
}
</script>

<style lang="sass">
</style>
